import Button from '@/components/Button'
import Tabs, { Tab } from '@/components/Tabs'
import useModal from '@/hooks/use-modal/index'
import usePage from '@/hooks/use-page'
import { useLocation, useNavigate } from '@/lib/router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CreateFolderModal from './components/create-folder-modal.jsx'
import Eclips from './components/eclips.jsx'
import FolderEclips from './components/folder-eclips.jsx'
import Templates from './components/templates.jsx'
import Breadcrumbs from '@/componentsDS/Breadcrumbs/index.jsx'

const Page = () => {
	/*=================================================
			General
	================================================*/

	const { t } = useTranslation()
	const { goTo } = useNavigate();
	const { currentPath } = useLocation();
	const [pageTitle, setPageTitle] = useState(t('eclipDataBundling'))

	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: `/`,
			},
			{
				label: 'Package Sharing',
				link: `/eclip`
			},
		]
	 })

	const { visible: isShowCreateFolderModal, show: showCreateFolderModal, hide: hideCreateFolderModel } = useModal()

	const tabsItems = [
		{ label: t('myEclip'), active: true, path: '/eclip' },
		{ label: t('sharedWithMe'), active: false, path: '/eclip/shared' },
		{ label: t('templates'), active: false, path: '/eclip/templates' },
	]?.map((item) => ({
		...item,
		active:
		item.path === currentPath ||
		(item.path === '/eclip' && currentPath?.includes('SEND')) ||
		(item.path === '/eclip/shared' && currentPath?.includes('RECEIVE')),
	}))

	const selectTab = (path) => {
		goTo(path)
	}

	const hanldeCreateEclip = () => {
		goTo('/eclip/create')
	}

	const hanldeRequestPackage = () => {
		goTo('/eclip/request')
	}

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">{pageTitle}</div>
				</div>

				<div className="title-header__right">
					<div className="overview__filter overview__button_wrap">
						{tabsItems[0].active && (
							<>
								<Button
									round
									ghost
									full
									text={'+ Create New Folder'}
									submit={showCreateFolderModal}
								/>
								<Button
									submit={hanldeCreateEclip}
									round
									full
									text={'+ Create New Package'}
								/>
							</>
						)}
						{tabsItems[1].active && (
							<>
								<Button
									round
									ghost
									full
									text={'+ Create New Folder'}
									submit={showCreateFolderModal}
									/>
									<Button
									submit={hanldeRequestPackage}
									round
									full
									text={'Request Package'}
								/>
							</>
						)}
					</div>
				</div>
			</div>

			<div>
				<Tabs>
					{tabsItems.map((item, index) => (
						<Tab
							key={index}
							label={item.label}
							active={item.active}
							onClick={() => selectTab(item.path)}
						/>
					))}
				</Tabs>
			</div>
			<div className="eclip-hr">
				<hr />
			</div>
			{/* <Switch>
				<Route path="/eclip" exact component={Eclips} />
				<Route path="/eclip/folder/:folderId/:type" component={FolderEclips} />
				<Route path={`/eclip/shared`} component={Eclips} />
				<Route path={`/eclip/templates`} component={Templates} />
			</Switch> */}

			{currentPath === '/eclip' && <Eclips />}
			{currentPath === '/eclip/shared' && <Eclips />}
			{currentPath === '/eclip/templates' && <Templates />}
			{currentPath?.includes('/eclip/folder') && <FolderEclips />}

			<CreateFolderModal
				visible={isShowCreateFolderModal}
				close={hideCreateFolderModel}
			/>
			{/* <DeleteFolderModal /> */}
			{/* <MoveFolderModal /> */}
		</>
	)
}

export default Page
